import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sticky top-0 z-20 w-full m-auto bg-gray-500 shadow"
}
const _hoisted_2 = { class: "px-3 py-3 mx-auto max-w-7xl sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "pr-16 sm:text-center sm:px-16" }
const _hoisted_4 = { class: "text-white" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "block sm:ml-4 sm:inline-block" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Continue editing your job post ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
const _hoisted_9 = { class: "absolute inset-y-0 right-0 flex items-start pt-1 pr-1 sm:pt-1 sm:pr-2 sm:items-start" }
const _hoisted_10 = {
  type: "button",
  class: "flex p-2 rounded-md hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-white"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Dismiss", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_XIcon = _resolveComponent("XIcon")!

  return (_ctx.show && _ctx.lastDraft && !_ctx.dismissed)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.lastDraft.title), 1),
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_RouterLink, {
                  to: {
                  name: 'job-view',
                  params: {
                    companySlug: _ctx.lastDraft.company?.username,
                    jobSlug: _ctx.lastDraft.slug,
                  },
                  query: _ctx.query,
                },
                  class: "font-bold text-white underline"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_XIcon, {
                class: "w-6 h-6 text-white",
                "aria-hidden": "true",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = false, _ctx.dismissed = true))
              })
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}